import React from 'react';
import PropTypes from 'prop-types';

const Logo = ({ width = '100', height = '100', className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width={width}
    height={height}
    className={`inline-block ${className}`}
    style={{ background: 'transparent' }}
  >
    <g fill="none" stroke="#2171CD">
      <circle cx="50" cy="50" r="45" strokeWidth="3"/>
      <path d="M50 5 Q50 50 50 95" strokeWidth="2.5"/>
      <path d="M5 50 Q50 50 95 50" strokeWidth="2.5"/>
      <path d="M20 20 Q50 50 80 80" strokeWidth="2.5"/>
      <path d="M20 80 Q50 50 80 20" strokeWidth="2.5"/>
      <path d="M50 25 L50 75" strokeWidth="6" strokeLinecap="round"/>
      <path d="M30 50 L70 50" strokeWidth="6" strokeLinecap="round"/>
    </g>
  </svg>
);

Logo.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
};

Logo.defaultProps = {
  width: '100',
  height: '100',
  className: ''
};

export default Logo;